const ROUTES = {
  home: '/',
  cgu: '/cgu',
  order: '/transactions/:transactionNumber/orders/:orderNumber',
  refund: '/transactions/:transactionNumber/orders/:orderNumber/refund',
  orderEnd: '/transactions/:transactionNumber/orders/:orderNumber/end',
  voucher: '/vouchers/refund',
  voucherEnd: '/vouchers/refund/end',
}

export default ROUTES
